(() => {
  const WISHLIST_KEY = 'nqln:wishlist';

  const loadWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (_) {
      return [];
    }
  };

  const saveWishlist = (arr) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
  };

  // id -> handle de cada producto guardado. La pagina de deseos necesita el
  // handle: Shopify no resuelve /products/{id}.js (da 404).
  const HANDLES_KEY = 'nqln:wishlist:handles';
  const loadHandles = () => {
    try {
      const m = JSON.parse(localStorage.getItem(HANDLES_KEY) || '{}');
      return m && typeof m === 'object' && !Array.isArray(m) ? m : {};
    } catch (_) {
      return {};
    }
  };
  const saveHandles = (m) => {
    try { localStorage.setItem(HANDLES_KEY, JSON.stringify(m)); } catch (_) {}
  };
  // Completa el handle de los productos guardados que aparecen en la pagina
  // (listas guardadas antes de que existiera este mapa).
  const fillHandles = () => {
    const list = loadWishlist();
    if (!list.length) return;
    const map = loadHandles();
    let changed = false;
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach((btn) => {
      const id = btn.dataset.productId;
      if (id && list.includes(id) && map[id] !== btn.dataset.productHandle) {
        map[id] = btn.dataset.productHandle;
        changed = true;
      }
    });
    if (changed) saveHandles(map);
  };

  const syncWishlistButton = (btn) => {
    const id = btn.dataset.productId;
    if (!id) return;
    btn.classList.toggle('is-active', loadWishlist().includes(id));
  };

  const syncAllWishlistButtons = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncWishlistButton);
  };

  const setBadgeCount = (selector, count) => {
    const n = Math.max(0, Number(count) || 0);
    document.querySelectorAll(selector).forEach((el) => {
      const truncate = el.dataset.badgeTruncate !== 'false';
      el.textContent = truncate && n > 99 ? '99+' : String(n);
      el.dataset.count = String(n);
      el.toggleAttribute('hidden', n === 0);
    });
    // Selector del label: [data-cart-count] -> [data-cart-count-label]
    // (insertar "-label" dentro del bracket del atributo, no fuera).
    const labelSelector = selector.replace(/\]$/, '-label]');
    document.querySelectorAll(labelSelector).forEach((el) => {
      const singular = el.dataset.singular || '';
      const plural = el.dataset.plural || singular;
      el.textContent = n === 1 ? singular : plural;
    });
  };

  const syncWishlistBadge = () => {
    setBadgeCount('[data-wishlist-count]', loadWishlist().length);
  };

  // Update optimista: suma delta a los badges de cart al vuelo,
  // sin esperar al fetch. syncCartBadge lo corrige luego si difiere.
  const bumpCartBadge = (delta) => {
    const anyBadge = document.querySelector('[data-cart-count]');
    const current = anyBadge ? parseInt(anyBadge.dataset.count || '0', 10) : 0;
    setBadgeCount('[data-cart-count]', Math.max(0, current + delta));
  };

  // Sync entre pestañas: cuando otra pestaña actualiza el carrito,
  // nos avisa via BroadcastChannel (mismo origen). Fallback: 'storage'
  // event de localStorage (dispara en OTRAS pestañas al escribir).
  let bc = null;
  try { bc = new BroadcastChannel('nqln:cart'); } catch (_) {}

  // Sections que Shopify puede re-renderizar via el parametro
  // `sections` de la Cart Ajax API. Deben ser section ids validos
  // (los que aparecen en header-group.json / mobile-bottom-bar).
  const CART_SECTIONS = 'header,header-desktop,mobile-bottom-bar';

  // Reemplaza todos los [data-cart-count] del DOM actual con los
  // que Shopify devolvio en el HTML re-renderizado de cada section.
  // Este es el approach oficial Shopify — evita fetch extra y
  // race conditions.
  const applySectionsHTML = (sections) => {
    if (!sections || typeof sections !== 'object') return;
    const parser = new DOMParser();
    Object.keys(sections).forEach((sectionId) => {
      const html = sections[sectionId];
      if (!html || typeof html !== 'string') return;
      const doc = parser.parseFromString(html, 'text/html');
      const freshBadges = doc.querySelectorAll('[data-cart-count]');
      freshBadges.forEach((fresh) => {
        // Match por atributo unico o por className del contenedor
        // para reemplazar el correcto en el DOM actual.
        const cls = fresh.className;
        const same = document.querySelector(
          '[data-cart-count]' + (cls ? '.' + cls.split(/\s+/).filter(Boolean).join('.') : '')
        );
        if (same) {
          same.textContent = fresh.textContent;
          same.dataset.count = fresh.dataset.count || '0';
          if (fresh.hasAttribute('hidden')) same.setAttribute('hidden', '');
          else same.removeAttribute('hidden');
        }
      });
    });
  };

  const syncCartBadge = async () => {
    try {
      // no-store: evita que el browser sirva un /cart.js cacheado
      // que devuelva un item_count viejo tras navegación.
      const r = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!r.ok) return;
      const cart = await r.json();
      setBadgeCount('[data-cart-count]', cart.item_count);
    } catch (_) {}
  };

  const broadcastCartUpdate = () => {
    try {
      if (bc) bc.postMessage({ type: 'cart:updated', at: Date.now() });
      // Fallback storage event: escribir un stamp dispara 'storage'
      // en las otras pestañas del mismo origen.
      localStorage.setItem('nqln:cart:stamp', String(Date.now()));
    } catch (_) {}
  };

  // Exponemos un helper global para que otras piezas del theme
  // (cart.liquid, product form, etc.) puedan avisar sin duplicar
  // la logica de BroadcastChannel + storage stamp.
  window.NQLN = window.NQLN || {};
  window.NQLN.broadcastCartUpdate = broadcastCartUpdate;
  window.NQLN.syncCartBadge = () => syncCartBadge();

  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.variantId;
      if (!variantId || addBtn.disabled) return;
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');

      // Update OPTIMISTA: incrementamos +1 inmediatamente para que el
      // usuario vea el badge cambiar sin esperar la red.
      bumpCartBadge(1);

      try {
        // Approach oficial Shopify: `sections` parameter en el body.
        // Shopify agrega el item Y en el mismo response devuelve el
        // HTML re-renderizado de cada section listada — con el badge
        // ya actualizado. Zero race conditions, zero fetch extra.
        // Ref: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: CART_SECTIONS,
            sections_url: window.location.pathname
          }),
        });

        const payload = await r.json().catch(() => null);
        if (!r.ok || (payload && payload.status && payload.status >= 400)) {
          bumpCartBadge(-1);
          const msg = (payload && (payload.description || payload.message)) || 'No se pudo agregar al carrito.';
          throw new Error(msg);
        }

        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        setTimeout(() => addBtn.classList.remove('is-added'), 1500);

        // 1) Aplicar HTML de secciones devuelto por Shopify (badge fresh).
        if (payload && payload.sections) {
          applySectionsHTML(payload.sections);
        } else {
          // Fallback si la version de Shopify no devolvio sections.
          await syncCartBadge();
        }

        // 2) Notificar a otras piezas (cart page, otras pestañas).
        document.dispatchEvent(new CustomEvent('cart:updated'));
        broadcastCartUpdate();
      } catch (_) {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-error');
        setTimeout(() => addBtn.classList.remove('is-error'), 1500);
      } finally {
        addBtn.disabled = false;
      }
      return;
    }

    const wishBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishBtn) {
      e.preventDefault();
      const id = wishBtn.dataset.productId;
      if (!id) return;
      const list = loadWishlist();
      const map = loadHandles();
      const idx = list.indexOf(id);
      if (idx >= 0) {
        list.splice(idx, 1);
        delete map[id];
      } else {
        list.push(id);
        if (wishBtn.dataset.productHandle) map[id] = wishBtn.dataset.productHandle;
      }
      saveWishlist(list);
      saveHandles(map);
      document.querySelectorAll(`[data-wishlist-toggle][data-product-id="${id}"]`).forEach(syncWishlistButton);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
    }
  });

  const bootSync = () => {
    fillHandles();
    syncAllWishlistButtons();
    syncWishlistBadge();
    syncCartBadge();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSync);
  } else {
    bootSync();
  }

  // pageshow dispara siempre — carga normal, bfcache, view transitions.
  window.addEventListener('pageshow', bootSync);

  // Cuando el user vuelve a la pestaña (cambia de app/tab y regresa)
  // re-sincronizamos por si en otro dispositivo/pestaña cambio algo.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      syncCartBadge();
      syncWishlistBadge();
    }
  });

  document.addEventListener('cart:updated', () => {
    syncCartBadge();
  });

  document.addEventListener('wishlist:updated', () => {
    syncAllWishlistButtons();
    syncWishlistBadge();
    // Wishlist ya se sincroniza cross-tab por 'storage' de la key
    // nqln:wishlist. Igual notificamos por si acaso.
    try { localStorage.setItem('nqln:wishlist:stamp', String(Date.now())); } catch (_) {}
  });

  // Cross-tab: escuchamos avisos de otras pestañas.
  if (bc) {
    bc.addEventListener('message', (e) => {
      if (e && e.data && e.data.type === 'cart:updated') syncCartBadge();
    });
  }

  window.addEventListener('storage', (e) => {
    if (!e || !e.key) return;
    if (e.key === 'nqln:cart:stamp') syncCartBadge();
    if (e.key === 'nqln:wishlist' || e.key === 'nqln:wishlist:stamp') {
      syncAllWishlistButtons();
      syncWishlistBadge();
    }
  });
})();

  // Contador de las tarjetas (franja .nq-cd): un solo temporizador para todas; se pausa con la
  // pestaña oculta y solo actualiza las que están en pantalla.
  (function () {
    if (window.__nqCd) return;
    window.__nqCd = true;
    function dos(n) { return n < 10 ? '0' + n : String(n); }
    function formato(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      return (d ? d + 'd ' : '') + dos(h) + ':' + dos(m) + ':' + dos(s);
    }
    function tick() {
      var now = Date.now(), vh = window.innerHeight;
      document.querySelectorAll('[data-nq-cd]').forEach(function (el) {
        var ms = parseInt(el.dataset.fin, 10) * 1000 - now;
        if (!(ms > 0)) { el.hidden = true; return; }
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var t = el.querySelector('[data-nq-cd-t]');
        if (t) t.textContent = formato(ms);
      });
    }
    tick();
    setInterval(function () { if (!document.hidden) tick(); }, 1000);
  })();
